import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { KeyRound } from "lucide-react";

const CustomTooltip = ({
  iconClass,
  icon,
  id,
  direction,
  text,
  containerClassName,
  customIcon,
  ...props
}) => {
  return (
    <React.Fragment>
      {props.tag
        ? !customIcon && (
            <props.tag className={containerClassName} id={id}>
              {" "}
              <KeyRound
                size={16}
                className={`${iconClass ? iconClass : ""}`}
                name={icon}
              />
            </props.tag>
          )
        : !customIcon && (
            <KeyRound
              size={16}
              className={`${iconClass ? iconClass : ""}`}
              name={icon}
              id={id}
            />
          )}

      {customIcon ? <KeyRound size={16} /> : null}
      <UncontrolledTooltip autohide={false} placement={direction} target={id}>
        {text}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};
export default CustomTooltip;
